export default __webpack_public_path__ + "static/media/lisnr-logo-lockup.75bd8c9e.svg";